import request from "@/utils/request.js"

// 合作身份-列表（跨租户）
export const listTenantOrganizeIgnore = (pageData, formData) => {
    return request.post(`/organize/ignoreTenant/${pageData.page}/${pageData.pageSize}`, formData)
}

// 查询非storeId合作身份-列表（跨租户）
export const listTenantOrganizeNotStoreIdIgnore = (pageData, formData) => {
    return request.get(`/organize/ignoreTenant/notStoreId/${pageData.page}/${pageData.pageSize}`, {params: formData})
}
